import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";
import { LOGGED_OUT_HOMEPAGE_REDESIGN_V2_111924 } from "@faire/web-api--source/indigofair/settings/LOGGED_OUT_HOMEPAGE_REDESIGN_V2_111924";
export var useSettingLoggedOutHomepageRedesignV2 = function() {
    return useSetting(LOGGED_OUT_HOMEPAGE_REDESIGN_V2_111924, IFourVariantXP.Bucket.CONTROL);
};
export var useIsLoggedOutHomepageRedesignV2 = function() {
    var settingHomepageV2 = useSettingLoggedOutHomepageRedesignV2();
    return settingHomepageV2 !== IFourVariantXP.Bucket.CONTROL;
};
export var useAssignSettingLoggedOutHomepageRedesignV2 = function() {
    return useAssignSetting(LOGGED_OUT_HOMEPAGE_REDESIGN_V2_111924);
};
